module.exports = __webpack_public_path__ + "static/img/9.5439cb6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/zh/9.png
// module id = LZXV
// module chunks = 0